import React from 'react'
// libs
import styled, { css } from 'styled-components'
//components
import Grid from '@mui/material/Grid2'
import { Paper as PaperOrigin } from 'components/UI'
// themes
import { colors } from 'themes'
import { LinkIconWithCounter as LinkIconWithCounterOrigin } from 'themes/views/objectivesList'
// icons
import LinkIconOrigin from 'src/icons/link-white.svg'
import ObjectivesIconOrigin from '@mui/icons-material/TrackChanges'
import PlansIconOrigin from '@mui/icons-material/Subject'
// utils
import { darken, size } from 'polished'

const Paper = styled(({ isGlobalSearch, children, ...props }) => <PaperOrigin {...props}>{children}</PaperOrigin>)`
  font-size: ${({ isGlobalSearch }) => (isGlobalSearch ? '14px' : '16px')};
  margin: 16px;
  padding: 16px;
`

const LinkIconWithCounter = styled(LinkIconWithCounterOrigin)`
  position: relative;
  height: unset;

  > div {
    position: absolute;
    top: -4px;
    left: -6px;
  }
`

const LinkIcon = styled(({ isGlobalSearch, isLinked, ...props }) => <LinkIconOrigin {...props} />)`
  ${size('24px')};

  ${({ isGlobalSearch }) =>
    isGlobalSearch &&
    css`
      ${size('18px')};
    `}
  path {
    fill: ${colors.gray850};
  }
`

const ObjectivesIcon = styled((props) => <ObjectivesIconOrigin {...props} />)`
  && {
    color: ${colors.gray850};
  }
`

const PlansIcon = styled((props) => <PlansIconOrigin {...props} />)`
  && {
    color: ${colors.gray850};
  }
`

const Path = styled('div')`
  color: ${colors.gray300};
  font-size: 12px;
  margin: 0 0 8px 32px;
  white-space: normal;
`

const Button = styled('button')`
  background-color: inherit;
  border: none;
  color: ${({ disabled }) => (disabled ? colors.gray280 : colors.blue500)};
  cursor: pointer;
  font-size: inherit;
  font-weight: bold;
  margin-right: 8px;
  outline: none;
  padding: 0;

  &:hover {
    color: ${({ disabled }) => (disabled ? colors.gray280 : darken(0.07, colors.blue500))};
  }
`

const Title = styled('div')<{ isGlobalSearch: boolean }>`
  align-items: center;
  display: flex;
  margin-left: 8px;
  max-width: ${({ isGlobalSearch }) => (isGlobalSearch ? '544px' : '512px')};
  text-align: justify;
  white-space: normal;
`

const ButtonsWrapper = styled(({ isGlobalSearch, ...props }) => <Grid {...props} />)<{ isGlobalSearch: boolean }>`
  && {
    margin-left: ${({ isGlobalSearch }) => (isGlobalSearch ? '32px' : '32px')};
  }
`

const CommentForm = styled(Grid)`
  && {
    width: 100%;
    flex-direction: column;
    margin: 0 0 8px 32px;
    gap: 12px;
  }
`

const Counter = styled('div')``

const Details = styled(Grid)`
  && {
    margin-bottom: 8px;

    svg {
      margin: 0;
      min-width: 24px;
    }
  }
`

const Wrapper = styled(Grid)`
  align-items: center;
  display: flex;
  flex-direction: row;
`

export {
  Button,
  ButtonsWrapper,
  CommentForm,
  Counter,
  Title,
  Details,
  LinkIcon,
  LinkIconWithCounter,
  ObjectivesIcon,
  Paper,
  Path,
  PlansIcon,
  Wrapper
}
